import AppConfig from "@/classes/AppConfig";
import axios from "axios";

const state = {
    currentLocation:{
      latitude: null,
      longitude: null
    },
    showStoreSelection: false,
    showStoreConfirmation: true,
    closestStores:[
    ]
}

const getters = {
    canViewStoreConfirmation() {
        return (AppConfig?.AppConf?.store_locator && state.showStoreConfirmation) ?? false
    },
    canViewStoreSelection() {
        return (AppConfig?.AppConf?.store_locator && state.showStoreSelection) ?? false
    },
    storeLocatorEnabled() {
        return !!AppConfig?.AppConf?.store_locator?.enabled;
    }
}

const actions = {
    toggleStoreSelection({commit, state}) {
        commit("SET_STORE_SELECTION", !state.showStoreSelection);
    },
    toggleStoreConfirmation({commit, state}) {
        commit("SET_STORE_CONFIRMATION", !state.showStoreConfirmation);
    },
    async fetchFiveClosestStores({state,dispatch}) {
        const {data} = await axios.get(`${process.env.VUE_APP_STORESAPI_URL}/getneareststores?bannerId=${AppConfig?.AppConf?.banner_id}&latitude=${state.currentLocation.latitude}&longitude=${state.currentLocation.longitude}&code=${process.env.VUE_APP_STORESAPI_CODE}`)
        if(data.length>0)
            dispatch('setFiveClosestStores',data)
    },
    setFiveClosestStores({commit},stores){
        commit("SET_FIVE_CLOSEST_STORES",stores)
    },
    setCurrentLocation({commit},loc){
        commit("SET_CURRENT_LOCATION",loc)
    }
}

const mutations = {
    SET_STORE_SELECTION(state, val) {
        state.showStoreSelection = val;
    },
    SET_STORE_CONFIRMATION(state, val) {
        state.showStoreConfirmation = val;
    },
    SET_FIVE_CLOSEST_STORES(state,stores){
        state.closestStores = stores
    },
    SET_CURRENT_LOCATION(state,loc){
        if(!loc) return
        state.currentLocation.latitude = loc.latitude || loc.lat
        state.currentLocation.longitude = loc.longitude || loc.lng
    }
}

export default {
    namespaced: true, state, getters, actions, mutations,
};
